<div [formGroup]="form"
     [kalLoading]="loading">

    <div *ngFor="let plan of planAndSections.controls; index as planIndex"
         formArrayName="planAndSections">

        <label>{{ plan.get('Libelle').value }} <span *ngIf="required" class="gup-U-color--red">*</span></label>

        <!--table-->
        <table [formGroupName]="planIndex" class="gup-C-table__basic">
            <thead>
                <tr>
                    <th>Section analytique</th>
                    <th>Pourcentage</th>
                    <th *ngIf="!shouldHideAmountColumn">Montant</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="isSectionListEmpty(plan) else sectionListTemplate">
                    <td>Aucune ligne</td>
                    <td></td>
                    <td *ngIf="!shouldHideAmountColumn"></td>
                    <td></td>
                </tr>

                <ng-template #sectionListTemplate>
                    <tr *ngFor="let section of plan.get('ListeSections').controls; index as sectionIndex"
                        formArrayName="ListeSections">

                        <ng-container [formGroupName]="sectionIndex"
                                      class="sectionsList">

                            <td>
                                <app-shared-analytical-plan-picker [analyticalPlanId]="plan.get('Id').value"
                                                                   formControlName="IdSectionAnalytique"
                                                                   placeholder="Sélectionner une section">
                                </app-shared-analytical-plan-picker>

                            </td>
                            <td>
                                <kal-input formControlName="Pourcentage"
                                           icon="%"
                                           type="currency">
                                </kal-input>
                            </td>
                            <td *ngIf="!shouldHideAmountColumn">
                                <kal-input formControlName="Montant"
                                           icon="euro"
                                           type="currency">
                                </kal-input>
                            </td>

                            <td>
                                <div>
                                    <kal-button *ngIf="sectionIndex > 0 || shouldHideAmountColumn"
                                                [kalMenuTriggerFor]="actionsMenu"
                                                kalTheme="tertiary">
                                        <kal-icon>more_horiz</kal-icon>
                                    </kal-button>

                                    <kal-menu #actionsMenu>
                                        <kal-option
                                            (selectionChange)="deleteSection(plan.get('ListeSections'), sectionIndex)">
                                            Supprimer
                                        </kal-option>
                                    </kal-menu>
                                </div>
                            </td>
                        </ng-container>

                    </tr>
                </ng-template>
            </tbody>
        </table>

        <ul *ngIf="plan.errors">
            <li *ngFor="let errorMessage of getErrorMessages(plan.errors)" class="gup-O-msg -error">
                {{ errorMessage }}
            </li>
        </ul>

        <a (click)="addSection(plan)"
           class="gup-C-moreInfos gup-O-link gup-U-margin-bottom--mini gup-U-margin-top--mini">
            <kal-icon>add</kal-icon>
            <span>Ajouter une section analytique</span>
        </a>

    </div>

</div>
